import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FullComponent } from './layouts/full/full.component';
import { BlankComponent } from './layouts/blank/blank.component';
import { TermsComponent } from './terms/terms.component';
import { PolicyComponent } from './policy/policy.component';
import { CallbackComponent } from './callback/callback.component';


export const routes: Routes = [
  {path:'callback/:lt', component: CallbackComponent, pathMatch: 'full'},
  {
    path: '',
    component: FullComponent,
    children: [
      { path: '', redirectTo: '/authentication/login', pathMatch: 'full' },
      { path: 'starter', loadChildren: './starter/starter.module#StarterModule' },
      { path: 'profile', loadChildren: './profile/profile.module#ProfileModule' },
      { path: 'documents', loadChildren: './documents/documents.module#DocumentsModule' },
      { path: 'kardex', loadChildren: './kardex/kardex.module#KardexModule' },
      { path: 'repositories', loadChildren: './repositories/repositories.module#RepositoriesModule' },
      { path: 'upload', loadChildren: './uploads/uploads.module#UploadsModule' },
     // { path: 'efos', loadChildren: './EFOSuploads/EFOSuploads.module#EFOSUploadsModule' },
      { path: 'supplier', loadChildren: './supplier/supplier.module#SupplierModule' },
      { path: 'smtp', loadChildren: './smtp/smtp.module#SmtpModule' },
      { path: 'notifications', loadChildren: './notifications/notifications.module#NotificationsModule' },
      { path: 'broker', loadChildren: './broker/broker.module#BrokerModule' },
      { path: 'log', loadChildren: './logSAP/log.module#LogModule' },
      { path: 'three-way-match', loadChildren: './three-way-match/three-way-match.module#ThreeWayModule'}
    ]
  },
  {
    path: '',
    component: BlankComponent,
    children: [
      {
        path: 'authentication',
        loadChildren: './authentication/authentication.module#AuthenticationModule'
      }
    ]
  },
  { path: 'terms', component: TermsComponent },
  { path: 'policy', component: PolicyComponent },
  {
    path: '**',
    redirectTo: '404'
  }];

@NgModule({
  imports: [RouterModule.forRoot(routes), NgbModule.forRoot()],
  exports: [RouterModule]
})
export class AppRoutingModule { }




// WEBPACK FOOTER //
// ./src/app/app-routing.module.ts